export const environment = {
  production: true,
  apiUrl: 'https://personality.hackampus.com/backend',
  apiToken: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczpcL1wvaGFja2VydS5lYnRlY2guY28uaWwiLCJpYXQiOjE2MDk4NjU0NDMsIm5iZiI6MTYwOTg2NTQ0MywiZXhwIjoxNjEyNDU3NDQzLCJkYXRhIjp7InVzZXIiOnsiaWQiOiIxIn19fQ.LSQcqlrq3mVlwsjBS9muEqpQJ-gIfrZQB_Vuu5plRFY'
};
